module.exports = __webpack_public_path__ + "static/media/messageSound.765be77c.mp3";